export const ADD_HOSTEL_REQUEST = 'ADD_HOSTEL_REQUEST'
export const ADD_HOSTEL_SUCCESS = 'ADD_HOSTEL_SUCCESS'
export const ADD_HOSTEL_FALIURE = 'ADD_HOSTEL_FALIURE'
